import { SignUpConfig, Verification } from "@/types/auth";
import axios, { AxiosResponse } from "axios";
import { Component, Vue } from "vue-property-decorator";

@Component
export class AuthHttp extends Vue {
	public login(email: string, password: string): Promise<AxiosResponse<any>> {
		return axios.post(process.env.VUE_APP_API_ENDPOINT + "/login", {
			email: email,
			password: password,
		});
	}

	public signUp(signUpConfig: SignUpConfig): Promise<AxiosResponse<any>> {
		return axios.post(process.env.VUE_APP_API_ENDPOINT + "/users", signUpConfig);
	}

	public requestResetPassword(email: string): Promise<AxiosResponse<any>> {
		return axios.post(process.env.VUE_APP_API_ENDPOINT + "/reset-password/request", {
			email,
		});
	}

	public verifyResetPasswordToken(token: string): Promise<AxiosResponse> {
		return axios.post(process.env.VUE_APP_API_ENDPOINT + "/reset-password/verify-token", {
			token,
		});
	}

	public resetPassword(token: string, newPassword: string): Promise<AxiosResponse> {
		return axios.post(process.env.VUE_APP_API_ENDPOINT + "/reset-password", {
			token,
			password: newPassword,
		});
	}

	public verifyEmail(verification: Verification): Promise<AxiosResponse> {
		return axios.post(process.env.VUE_APP_API_ENDPOINT + "/users/emailVerify", verification);
	}

	public getCurrentUser(): Promise<AxiosResponse<any>> {
		return axios.get(process.env.VUE_APP_API_ENDPOINT + "/users/me", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("access_token"),
			},
		});
	}

	public resendVerificationEmail(email: string): Promise<AxiosResponse> {
		return axios.post(process.env.VUE_APP_API_ENDPOINT + "/users/resend-verify-email", {
			email: email,
		});
	}
}
